
<ng-container *ngIf="showDeviceRegistrationModal">
	<app-web-kamona-message-widget
		[modalType]="ModalType.CUSTOM">
		<ng-container>
			<ng-container *ngTemplateOutlet="deviceRegistrationTemplate"></ng-container>
		</ng-container>
	</app-web-kamona-message-widget>
</ng-container>

<ng-container *ngIf="isUserSuspended">
	<app-web-kamona-message-widget
		[title]="suspendedTitle"
		[iconType]="iconType"
		[btnText]="btnText"
		[btnType]="btnType"
		(emitCancel)="closeUserSuspensionModal()"
		[suspensionReleaseTimeEpoch]="suspensionReleaseTimeEpoch"
		[description]="suspendedDescription">
	</app-web-kamona-message-widget>
</ng-container>

<div class="bg-white w-[486px] min-h-[319px] pt-[60px] rounded-[16px] px-[48px]">
   <div class="flex flex-col gap-[32px]">
	   <div class="flex flex-col gap-[24px]">
		   <div (click)="goBack()" *ngIf="currentForm === SignInForm.PASSWORD" class="cursor-pointer">
			   <svg width="59" height="18" viewBox="0 0 59 18" fill="none" xmlns="http://www.w3.org/2000/svg">
				   <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7803 14.0303C10.4874 14.3232 10.0126 14.3232 9.71967 14.0303L5.21967 9.53033C4.92678 9.23744 4.92678 8.76256 5.21967 8.46967L9.71967 3.96967C10.0126 3.67678 10.4874 3.67678 10.7803 3.96967C11.0732 4.26256 11.0732 4.73744 10.7803 5.03033L6.81066 9L10.7803 12.9697C11.0732 13.2626 11.0732 13.7374 10.7803 14.0303Z" fill="#0361F0"/>
				   <path d="M27.2514 14V3.81818H30.9801C31.7027 3.81818 32.3009 3.9375 32.7749 4.17614C33.2488 4.41146 33.6035 4.7313 33.8388 5.13565C34.0741 5.53669 34.1918 5.98911 34.1918 6.4929C34.1918 6.91714 34.1139 7.27509 33.9581 7.56676C33.8023 7.85511 33.5935 8.08712 33.3317 8.26278C33.0732 8.43513 32.7881 8.56108 32.4766 8.64062V8.74006C32.8146 8.75663 33.1444 8.866 33.4659 9.06818C33.7907 9.26705 34.0592 9.55043 34.2713 9.91832C34.4834 10.2862 34.5895 10.7337 34.5895 11.2607C34.5895 11.781 34.4669 12.2483 34.2216 12.6626C33.9796 13.0736 33.6051 13.4001 33.098 13.642C32.5909 13.8807 31.9429 14 31.1541 14H27.2514ZM28.7876 12.6825H31.005C31.7408 12.6825 32.2678 12.54 32.5859 12.255C32.9041 11.9699 33.0632 11.6136 33.0632 11.1861C33.0632 10.8646 32.982 10.5696 32.8196 10.3011C32.6572 10.0327 32.4252 9.81889 32.1236 9.6598C31.8253 9.50071 31.4706 9.42116 31.0597 9.42116H28.7876V12.6825ZM28.7876 8.22301H30.8459C31.1906 8.22301 31.5005 8.15672 31.7756 8.02415C32.054 7.89157 32.2744 7.70597 32.4368 7.46733C32.6025 7.22538 32.6854 6.94034 32.6854 6.61222C32.6854 6.19129 32.5379 5.8383 32.2429 5.55327C31.9479 5.26823 31.4955 5.12571 30.8857 5.12571H28.7876V8.22301ZM38.5146 14.169C38.0307 14.169 37.5932 14.0795 37.2021 13.9006C36.811 13.7183 36.5011 13.4548 36.2724 13.1101C36.047 12.7654 35.9343 12.3428 35.9343 11.8423C35.9343 11.4115 36.0172 11.0568 36.1829 10.7784C36.3486 10.5 36.5723 10.2796 36.854 10.1172C37.1358 9.95478 37.4506 9.83215 37.7987 9.74929C38.1467 9.66643 38.5013 9.60346 38.8626 9.56037C39.32 9.50734 39.6912 9.46425 39.9762 9.43111C40.2612 9.39465 40.4684 9.33665 40.5977 9.2571C40.7269 9.17756 40.7915 9.0483 40.7915 8.86932V8.83452C40.7915 8.40033 40.6689 8.06392 40.4237 7.82528C40.1817 7.58665 39.8204 7.46733 39.3398 7.46733C38.8394 7.46733 38.445 7.57836 38.1566 7.80043C37.8716 8.01918 37.6744 8.26278 37.565 8.53125L36.168 8.21307C36.3337 7.74905 36.5756 7.37453 36.8938 7.08949C37.2153 6.80114 37.5849 6.59233 38.0025 6.46307C38.4201 6.33049 38.8593 6.2642 39.32 6.2642C39.6249 6.2642 39.948 6.30066 40.2894 6.37358C40.6341 6.44318 40.9556 6.57244 41.2539 6.76136C41.5555 6.95028 41.8024 7.22041 41.9947 7.57173C42.1869 7.91974 42.283 8.37216 42.283 8.92898V14H40.8313V12.956H40.7717C40.6755 13.1482 40.5314 13.3371 40.3391 13.5227C40.1469 13.7083 39.9 13.8625 39.5984 13.9851C39.2968 14.1077 38.9355 14.169 38.5146 14.169ZM38.8377 12.9759C39.2487 12.9759 39.6 12.8946 39.8917 12.7322C40.1867 12.5698 40.4104 12.3577 40.5629 12.0959C40.7186 11.8307 40.7965 11.5473 40.7965 11.2457V10.2614C40.7435 10.3144 40.6407 10.3641 40.4883 10.4105C40.3391 10.4536 40.1684 10.4917 39.9762 10.5249C39.784 10.5547 39.5967 10.5829 39.4144 10.6094C39.2321 10.6326 39.0797 10.6525 38.957 10.669C38.6687 10.7055 38.4052 10.7668 38.1665 10.853C37.9312 10.9392 37.7423 11.0634 37.5998 11.2259C37.4606 11.3849 37.391 11.5971 37.391 11.8622C37.391 12.2301 37.5269 12.5085 37.7987 12.6974C38.0704 12.883 38.4168 12.9759 38.8377 12.9759ZM47.4796 14.1541C46.7405 14.1541 46.1041 13.9867 45.5705 13.652C45.0402 13.3139 44.6325 12.8482 44.3475 12.255C44.0624 11.6617 43.9199 10.9822 43.9199 10.2166C43.9199 9.44105 44.0658 8.75663 44.3574 8.16335C44.6491 7.56676 45.0601 7.10109 45.5904 6.76633C46.1207 6.43158 46.7454 6.2642 47.4647 6.2642C48.0447 6.2642 48.5617 6.37192 49.0158 6.58736C49.4699 6.79948 49.8361 7.09777 50.1145 7.48224C50.3962 7.86671 50.5636 8.31581 50.6167 8.82955H49.1699C49.0904 8.47159 48.9081 8.16335 48.623 7.90483C48.3413 7.64631 47.9635 7.51705 47.4895 7.51705C47.0752 7.51705 46.7123 7.62642 46.4007 7.84517C46.0925 8.06061 45.8522 8.36884 45.6799 8.76989C45.5075 9.16761 45.4213 9.63826 45.4213 10.1818C45.4213 10.7386 45.5059 11.2192 45.6749 11.6236C45.8439 12.0279 46.0826 12.3411 46.3908 12.5632C46.7024 12.7853 47.0686 12.8963 47.4895 12.8963C47.7712 12.8963 48.0265 12.8449 48.2551 12.7422C48.4872 12.6361 48.681 12.4853 48.8368 12.2898C48.9959 12.0942 49.1069 11.8589 49.1699 11.5838H50.6167C50.5636 12.0777 50.4029 12.5185 50.1344 12.9062C49.8659 13.294 49.5063 13.599 49.0556 13.821C48.6081 14.0431 48.0828 14.1541 47.4796 14.1541ZM53.5735 11.4098L53.5636 9.59517H53.8221L56.8647 6.36364H58.6445L55.1744 10.0426H54.9407L53.5735 11.4098ZM52.2063 14V3.81818H53.6928V14H52.2063ZM57.0288 14L54.2944 10.3707L55.3185 9.33168L58.8533 14H57.0288Z" fill="#0361F0"/>
			   </svg>
		   </div>
		   <div class="flex flex-col gap-[8px]">
			   <div class="text-[#1A1A1A] leading-[34.72px] text-[28px] font-bold">{{title}}</div>
			   <div class="leading-[19.6px] text-black text-[14px] font-normal">{{subTitle}}</div>
		   </div>
		   <ng-container [ngSwitch]="currentForm">
			   <ng-container *ngSwitchDefault>
				   <ng-container *ngTemplateOutlet="usernameTemplate"></ng-container>
			   </ng-container>
			   <ng-container *ngSwitchCase="SignInForm.PASSWORD">
				   <ng-container *ngTemplateOutlet="passwordTemplate"></ng-container>
			   </ng-container>
		   </ng-container>
	   </div>
	   <div class="flex flex-col gap-[32px]">
		   <ng-container [ngSwitch]="currentForm">
			   <ng-container *ngSwitchDefault>
				   <ng-container *ngTemplateOutlet="phoneNumberBtn"></ng-container>
			   </ng-container>
			   <ng-container *ngSwitchCase="SignInForm.PASSWORD">
				   <ng-container *ngTemplateOutlet="usernameBtn"></ng-container>
			   </ng-container>
		   </ng-container>
	   </div>
   </div>
</div>

<ng-template #usernameTemplate>
	<ng-container *ngTemplateOutlet="tapTemplate"></ng-container>
</ng-template>

<ng-template #phoneNumberBtn>
	<app-kamona-custom-button
		(submitForm)="getLoginType()"
		[isBlock]="true"
		[isDisabled]="usernameType === UserNameType.PHONENUMBER ? phoneNumberForm?.invalid : usernameForm?.invalid"
		[isSubmitting]="loadingLoginType"
		[type]="'primary'"
		text="Next">
	</app-kamona-custom-button>
	<div class="py-[16px]">
		<div *ngIf="nzSelectedIndex" (click)="forgotUsername()"
		class="text-[#0361F0] cursor-pointer text-[14px] font-medium leading-[17.36px] flex justify-center">
			Forgot Username?
		</div>
	</div>
</ng-template>

<ng-template #usernameBtn>
	<app-kamona-custom-button
		(submitForm)="handleSignIn()"
		[isDisabled]="passwordType === PasswordType.PASSCODE ? passcode?.length !== 6 : password?.length < 6"
		[isBlock]="true"
		[isSubmitting]="loadingLoginType"
		[type]="'primary'"
		text="Login">
	</app-kamona-custom-button>
	<div (click)="handleForgotCredentials()" class="py-[16px] text-[#0361F0] cursor-pointer text-[14px] font-medium leading-[17.36px] flex justify-center">
		Forgot {{passwordType | titlecase}}
	</div>
</ng-template>

<ng-template #tapTemplate>
	<nz-tabset [nzSelectedIndex]="nzSelectedIndex" [nzType]="tabType" (nzSelectedIndexChange)="setCurrentTab($event)">
		<nz-tab nzTitle="Phone Number">
			<app-kamona-phone-number-field
				[input]="phoneNumber">
			</app-kamona-phone-number-field>
		</nz-tab>
		<nz-tab nzTitle="Username">
			<app-kamona-input-field [input]="username">
			</app-kamona-input-field>
		</nz-tab>
	</nz-tabset>
</ng-template>
<ng-template #passwordTemplate>
	<ng-container [ngSwitch]="passwordType">
		<ng-container *ngSwitchDefault>
			<app-web-kamona-passcode-widget
				[minHeight]="44"
				[usePasscodeForm]="false"
				(emitSubmit)="setPasscode($event)">
			</app-web-kamona-passcode-widget>
		</ng-container>
		<ng-container *ngSwitchCase="PasswordType.PASSWORD">
			<app-web-kamona-password-widget
				[usePasswordForm]="false"
				[minHeight]="44"
				oldPasswordPlaceHolder="Enter Password"
				(emitSubmit)="setPassword($event)">
			</app-web-kamona-password-widget>
		</ng-container>
	</ng-container>
</ng-template>

<ng-template #deviceRegistrationTemplate>
	<div class="bg-white rounded-[16px] flex flex-col gap-[16px]">
		<div class="flex justify-center">
			<svg width="46" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_13056_54542)">
					<circle cx="23" cy="22.5" r="22.5" fill="#0361F0"/>
					<path d="M18.4998 25V20.9801L24.5398 20.9821L24.5198 29.0001H26.5395V33H20.4995V25H18.4998Z" fill="white"/>
					<path d="M20.4995 17.0381V13H24.5398V17.0381H20.4995Z" fill="white"/>
				</g>
				<defs>
					<clipPath id="clip0_13056_54542">
						<rect width="45" height="45" fill="white" transform="translate(0.5)"/>
					</clipPath>
				</defs>
			</svg>
		</div>
		<div class="flex flex-col gap-[8px] justify-center text-[#1A1A1A]">
			<div class="text-[24px] font-bold leading-[29.76px]">
				Register Device
			</div>
			<div class="text-[14px] font-normal leading-[19.6px]">
				Your login was successful but you need to register this browser device.
			</div>
		</div>
		<div class="mt-[24px] flex items-center">
			<div class="basis-1/2">
				<div (click)="closeDeviceRegistrationModal()" class="text-[#0361F0] cursor-pointer leading-[17.36px] text-[14px] font-medium">Close</div>
			</div>
			<div class="basis-1/2">
				<div (click)="registerDevice()" class="bg-[#0361F0] py-[6px] h-[48px] px-[16px] rounded-[8px] flex items-center justify-center cursor-pointer text-white leading-[17.36px] text-[14px] font-medium">
					Register Device
				</div>
			</div>
		</div>
	</div>
</ng-template>
